/**
* map JS
* -----------------------------------------------------------------------------
*
* All the JS for the map component.
*/

// VARS that are set in map.php:
// mapLocations - array of objects [{address, city, state, zip, coordinates: {lat, lng}}]
// mapStyle - url string of mapbox studio style link
// mapKey - string of mapbox api key
// map icon can be setup in the map.css .markers class and can be an svg or png or custom text. Sky's the limit. You do more with the .markers element in the addMarkers() function
( function( app ) {
  const COMPONENT = {

    className: 'map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // function to allow .remove() to work for removing open popups in createPopup()
      if ( !( 'remove' in Element.prototype ) ) {
        Element.prototype.remove = function() {
          if ( this.parentNode ) {
            this.parentNode.removeChild( this );
          }
        };
      }
      // mapKey variable is set in the PHP file
      mapboxgl.accessToken = llMapbox.token;

      let allLocations = [];
      let currentMap = null;

      $( '.map' ).each( function() {
        const mapLocations = $( this ).data( 'locations' );
        const mapId = 'map-' + $( this ).attr( 'id' );
        if ( mapLocations ) loadMap( mapLocations, mapId );
      } );

      function loadMap( mapLocations, mapId ) {
        allLocations = mapLocations;
        const places = [];
        let bounds;

        if ( mapLocations.length > 1 ) {
          bounds = new mapboxgl.LngLatBounds();
        }

        mapLocations.forEach( ( loc, index ) => {
          const place = {
            type: 'Feature',
            properties: {
              id: index,
              description:
              `<span class="font-medium text-brand-navy mt-2 px-5 block text-center">${loc.title}</span>
              <address class="p-2 text-xs not-italic text-center">
                <span class="block">${loc.address.street}</span>
                <span>${loc.address.street_2}</span>
                <span class="block">${loc.address.city}, ${loc.address.state} ${loc.address.zip}</span>
              </address>
              <div class="text-center mb-3"><button data-modal="#map-location-${index}" class="text-sm underline js-init-popup text-brand-navy underline-offset-4 hover:no-underline hover:text-brand-blue" data-component="modal">Learn More</button></div>`,
            },
            geometry: {
              type: 'Point',
              coordinates: [parseFloat( loc.coordinates.long ), parseFloat( loc.coordinates.lat )],
            },
          };

          places.push( place );

          if ( mapLocations.length > 1 ) {
            bounds.extend( place.geometry.coordinates );
          }
        } );

        let center;
        if ( mapLocations.length === 1 ) {
          center = places[0].geometry.coordinates;
        } else {
          center = bounds.getCenter();
        }

        if ( mapboxgl.supported() ) {
          currentMap = new mapboxgl.Map( {
            container: mapId,
            style: llMapbox.style,
            center: center,
            zoom: 10,
          } );
        } else {
          console.warn( 'Mapbox not supported on this browser/device.' );
          document.getElementById( mapId ).innerHTML = '<p>Map not supported on this device.</p>';
          $( '.map' ).addClass( 'is-error' );
          return;
        }


        // if there are multiple locations will make sure
        // all locations are visible on load
        // padding can be increased or decreased to make sure
        // there is more space between the furthest markers and the edge of the map
        if ( mapLocations.length > 1 ) {
          currentMap.fitBounds( bounds, {padding: 80, maxZoom: 16} );
        }

        // add locations from the places array to the map
        // and create the markers
        // and add the map navigations controls
        currentMap.on( 'load', () => {
          // add this "geojson" object to the map, passing in the places array
          currentMap.addSource( 'points', {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: places,
            },
          } );

          addMarkers( places, currentMap );

          currentMap.addControl( new mapboxgl.NavigationControl() );
        } );
      }

      let activeMarkers = [];

      function addMarkers( locations ) {
        // Clear any leftover references
        activeMarkers = [];

        locations.forEach( ( marker, i ) => {
          const el = document.createElement( 'div' );
          el.id = 'marker-' + marker.properties.id;
          el.className = 'marker';

          const m = new mapboxgl.Marker( el, {offset: [0, -23]} )
              .setLngLat( marker.geometry.coordinates )
              .addTo( currentMap );

          el.addEventListener( 'click', ( e ) => {
            createPopUp( marker, currentMap );
            e.stopPropagation();
          } );

          activeMarkers.push( m ); // keep reference
        } );
      }

      function clearMarkers() {
        activeMarkers.forEach( ( marker ) => marker.remove() );
        activeMarkers = [];
      }


      function createPopUp( currentLocation ) {
        const popUps = document.getElementsByClassName( 'mapboxgl-popup' );
        // remove popups if any are open
        if ( popUps[0] ) popUps[0].remove();

        new mapboxgl.Popup( {offset: {'bottom': [0, -49]}} )
            .setLngLat( currentLocation.geometry.coordinates )
            .setHTML( currentLocation.properties.description )
            .addTo( currentMap );
      }

      function filterMarkers( filterFn ) {
        const filtered = allLocations.filter( filterFn );

        clearMarkers(); // remove old markers

        const features = filtered.map( ( loc, index ) => ( {
          type: 'Feature',
          properties: {
            id: index,
            description:
              `<span class="font-medium text-brand-navy mt-2 px-5 block text-center">${loc.title}</span>
              <address class="p-2 text-xs not-italic text-center">
                <span class="block">${loc.address.street}</span>
                <span>${loc.address.street_2}</span>
                <span class="block">${loc.address.city}, ${loc.address.state} ${loc.address.zip}</span>
              </address>
              <div class="text-center mb-3"><button data-modal="#map-location-${index}" class="text-sm underline js-init-popup text-brand-navy underline-offset-4 hover:no-underline hover:text-brand-blue" data-component="modal">Learn More</button></div>`,
          },
          geometry: {
            type: 'Point',
            coordinates: [parseFloat( loc.coordinates.long ), parseFloat( loc.coordinates.lat )],
          },
        } ) );

        addMarkers( features ); // add only filtered markers

        if ( filtered.length > 1 ) {
          const bounds = new mapboxgl.LngLatBounds();
          features.forEach( ( f ) => bounds.extend( f.geometry.coordinates ) );
          currentMap.fitBounds( bounds, {padding: 80} );
        } else if ( filtered.length === 1 ) {
          currentMap.flyTo( {center: features[0].geometry.coordinates, zoom: 10} );
        }
      }

      $( document ).on( 'click', '.map button.map__filter', function() {
        const filter = $( this ).find( 'span' ).text();
        if ( filter == 'All' ) {
          if ( mapboxgl.supported() ) {
            filterMarkers( () => true );
          }
          $( '.map__card' ).show();
        } else {
          if ( mapboxgl.supported() ) {
            filterMarkers( ( loc ) => loc.categories.includes( filter ) );
          }

          $( '.map__card' ).each( function() {
            const categories = $( this ).data( 'categories' ).split( ',' );

            if ( !categories.includes( filter ) ) {
              $( this ).hide();
            } else {
              $( this ).show();
            }
          } );
        }
      } );

      $( '.map__select-filter' ).on( 'change', function() {
        $( '.map__filter[data-filter="' + $( this ).val() + '"]' ).trigger( 'click' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'map', COMPONENT );
} )( app );
